import { render } from "./SleepResults.vue?vue&type=template&id=4ac083df"
import script from "./SleepResults.vue?vue&type=script&lang=js"
export * from "./SleepResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__